import {
  COMPANIES_SLUG,
  CURRENT_JOBS_SLUG,
  CURRENT_MODELS_SLUG,
  DASHBOARD_SLUG,
  INFORMATION_SLUG,
  OPERATIONS_SLUG,
  OVERVIEW_SLUG,
  PAST_JOBS_SLUG,
  PAST_MODELS_SLUG,
  PREVIOUS_REPORTS_SLUG,
  SETTINGS_SLUG,
  SUBSCRIPTION_SLUG,
  WORKBOARD_SLUG,
} from 'dashboard409a/common/constants';

const DASHBOARD_COMPANY_URL = (companySlug: string) => `/${DASHBOARD_SLUG}/${COMPANIES_SLUG}/${companySlug}`;

export const dashboardCompanyOverviewUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${OVERVIEW_SLUG}`;

export const dashboardCompanyPreviousReportsUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${PREVIOUS_REPORTS_SLUG}`;

export const dashboardCompanySettingsUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${SETTINGS_SLUG}`;

export const dashboardCompanySubscriptionUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${SUBSCRIPTION_SLUG}`;

export const dashboardCompanyInformationUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${INFORMATION_SLUG}`;

export const dashboardCompanyOperationsUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${OPERATIONS_SLUG}`;

export const dashboardCompanyOperationsValuationUrl = (companySlug: string, valuationId: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${OPERATIONS_SLUG}/${valuationId}`;

const WORKBOARD_URL = `/${WORKBOARD_SLUG}`;

export const WORKBOARD_CURRENT_JOBS_URL = `${WORKBOARD_URL}/${CURRENT_JOBS_SLUG}`;
export const WORKBOARD_PAST_JOBS_URL = `${WORKBOARD_URL}/${PAST_JOBS_SLUG}`;
export const WORKBOARD_CURRENT_MODELS_URL = `${WORKBOARD_URL}/${CURRENT_MODELS_SLUG}`;
export const WORKBOARD_PAST_MODELS_URL = `${WORKBOARD_URL}/${PAST_MODELS_SLUG}`;
